import { useCallback } from 'react';

import { smallUploadUrlInfoSelector } from '@air/redux-uploader';
import { useUploadSmall } from '@air/upload-utils';

import { type UploadTaskParams } from '~/components/Upload/hooks/types';
import { usePublicUploadUrlsManager } from '~/providers/PublicUploadUrlsManagerProvider';
import { metadataForPublicUploadSelector } from '~/store/publicUploadMetadata/selectors';
import { useAirStore } from '~/utils/ReduxUtils';

export const useUploadSmallPublicFile = () => {
  const store = useAirStore();
  const { uploadSmall } = useUploadSmall();
  const { manager: uploadUrlsManager } = usePublicUploadUrlsManager();

  const uploadSmallPublicFile = useCallback(
    async ({ uploadId, onUploadFinished, onUploadStarted, onError }: UploadTaskParams) => {
      await uploadSmall({
        uploadId,
        onUploadStarted,
        onUploadFinished,
        onError,
        getUploadUrls: async () => {
          const uploadMetadata = metadataForPublicUploadSelector(store.getState(), uploadId);
          if (uploadMetadata?.sessionId) {
            const uploadUrlInfo = smallUploadUrlInfoSelector(store.getState(), uploadId);
            const urlInfo = uploadUrlInfo ?? (await uploadUrlsManager.getSmallUploadUrl(uploadId));
            return urlInfo;
          }
        },
      });
    },
    [store, uploadSmall, uploadUrlsManager.getSmallUploadUrl],
  );

  return {
    uploadSmallPublicFile,
  };
};
